import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import {
  register,
  resndOTP,
  verifyOTP,
} from "../../../Redux/actions/authActions";
import { addSurvey } from "../../../Redux/actions/commonActtion";
import VerifyOTPModal from "../VerifyOtp";
import SignUpWithGoogle from "../../GoogleSignUp/SignUpWithGoogle";
import { New_ScrollX2025 } from "../../../assets/icons";
import "./signup.css";
import EmailVerifyOTP from "../EmailVerifyOTP";
import useAlignHeaderBrand from "../../utils/useAlignHeaderBrand";

/* ─── Survey option data ───────────────────────────────────────────────────── */
export const ROLE_OPTIONS = [
  { value: "director", label: "Director" },
  { value: "producer", label: "Producer" },
  { value: "editor", label: "Editor" },
  { value: "postProductionSupervisor", label: "Post Production Supervisor" },
  { value: "postCoordinator", label: "Post Coordinator" },
  { value: "assistantEditor", label: "Assistant Editor" },
  { value: "vfxSupervisor", label: "VFX Supervisor" },
  { value: "cinematographer", label: "Cinematographer" },
  { value: "soundDesigner", label: "Sound Designer" },
  { value: "student", label: "Student / Emerging Filmmaker" },
  { value: "other", label: "Other" },
];

export const DISCOVER_OPTIONS = [
  { value: "googleSearch", label: "Google / Search" },
  { value: "wordOfMouth", label: "Word of mouth / Colleague" },
  { value: "socialMedia", label: "Social media" },
  { value: "filmFestival", label: "Film festival or event" },
  { value: "youtubeAds", label: "YouTube or video" },
  { value: "reddit", label: "Reddit or online community" },
  { value: "blog", label: "Blog or article" },
  { value: "fromAFriend", label: "Other" },
];

/* ─── Component ────────────────────────────────────────────────────────────── */
export default function NewSignup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const otpType = "signUp";

  /* ── State ── */
  const [otp, setOpt] = useState("");
  const [inValidOtp, setInValidOtp] = useState("");
  const [isSignUpSuccess, setIsSignUpSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [signupLoading, setSignupLoading] = useState(false);
  const [terms, setTerms] = useState(false);
  const [termsConditionsError, setTermsConditionError] = useState("");
  const [error, setError] = useState("");

  const [answer, setAnswer] = useState({ value: "", label: "" }); // discover
  const [answerTwo, setAnswerTwo] = useState({ value: "", label: "" }); // role

  const [form, setForm] = useState({
    data: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    },
    errorMessage: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    },
  });

  const formWrapRef = useRef(null);
  const brandRef = useRef(null);
  useAlignHeaderBrand(formWrapRef, brandRef);

  /* ── Handlers ── */
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      const errMsg = { ...prev.errorMessage };
      if (name === "firstName" || name === "lastName") {
        errMsg[name] = value.length < 2 ? "Name is too short" : "";
      } else if (name === "password") {
        errMsg[name] =
          value.length < 8 ? "Password must be at least 8 characters" : "";
      } else {
        errMsg[name] = "";
      }
      return {
        ...prev,
        data: { ...prev.data, [name]: value },
        errorMessage: errMsg,
      };
    });
  };

  const onSubmitSurvey = async (answerVal, answerTwoVal) => {
    if (!answerVal) return;
    try {
      await dispatch(addSurvey(answerVal, answerTwoVal));
      localStorage.setItem("userFilledSurvey", JSON.stringify(true));
    } catch {
      // silent — not blocking navigation
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!answer.value) {
      setError("Please select how you discovered ScrollX.");
      return;
    }
    setSignupLoading(true);
    const res = await dispatch(register(form.data));
    const resError = res?.response?.data?.error;
    if (res?.status === 200 && res?.data?.success) {
      setSignupLoading(false);
      setIsSignUpSuccess(true);
    } else if (resError?.includes("User with email")) {
      setSignupLoading(false);
      setForm((prev) => ({
        ...prev,
        errorMessage: { ...prev.errorMessage, email: "Email already exists" },
      }));
    } else {
      setSignupLoading(false);
    }
  };

  const handleSubmitOtp = async () => {
    if (!otp) return;
    const user = JSON.parse(localStorage.getItem("dup-user"));
    const res = await dispatch(verifyOTP(user.email, otp, otpType, ""));
    if (res?.data === "Successfully verified") {
      setIsSignUpSuccess(false);
      onSubmitSurvey(answer.value, answerTwo.value);
      navigate("/plans");
      setOpt("");
      setInValidOtp("");
    } else if (res?.response?.data === "Invalid otp") {
      setInValidOtp(res?.response?.data);
    }
  };

  const handleResendOtp = async () => {
    const user = JSON.parse(localStorage.getItem("dup-user") || "{}");
    const res = await dispatch(resndOTP(user.email, "signUp"));
    if (res?.data?.message === "otp Resent successsful") {
      setInValidOtp("OTP resent — check your email.");
    }
  };

useEffect(() => {
  document.body.style.backgroundColor = "#0d0d1a"; // match your dark bg
  document.body.style.margin = "0";
  return () => {
    document.body.style.backgroundColor = "";
  };
}, []);

  /* ── Render ── */
  if (isSignUpSuccess) {
    return (
      <EmailVerifyOTP
        isSignUpSuccess={isSignUpSuccess}
        setIsSignUpSuccess={setIsSignUpSuccess}
        otp={otp}
        setOpt={setOpt}
        handleSubmitOtp={handleSubmitOtp}
        handleResendOtp={handleResendOtp}
        inValidOtp={inValidOtp}
        setInValidOtp={setInValidOtp}
        email={form.data.email}
      />
    );
  }

  return (
    <div className="signup-container"  style={{ minHeight: "100vh", minHeight: "-webkit-fill-available" }}>
      {/* Loading overlay */}
      {signupLoading && (
        <div className="sx-loader-overlay">
          <div className="sx-spinner" />
          <p style={{ marginTop: 16, color: "#f0eeff", fontSize: 14 }}>
            Signing up…
          </p>
        </div>
      )}

      <div className="sx-particles" />

      <div className="sx-shell">
        {/* ── Top bar ── */}
        <header className="header-topbar">
          <nav className="w-full flex justify-between">
            <a href="https://scrollx.io/" className="nav-logo" ref={brandRef}>
              <span className="nav-logo-icon"><img className="logo-img999 " src={New_ScrollX2025} alt="icon" /></span>
              <span>ScrollX</span>
            </a>

            <div className="top-actionslogin">
              <span className=" hidden sm:block">Already have an account?</span>
                <Link to="/login">
                  <span className="text-white  sm:block xl:text-[15px] manrope-300 ">Log In</span>
                </Link>
            </div>
          </nav>
        </header>

        <main className="sx-page">
          {/* ── Left — Form ── */}
          <section className="sx-left">
            <div className="sx-form-wrap" ref={formWrapRef}>
              <p className="sx-eyebrow">Get Started Now</p>
              <h1 className="sx-h1">
                Create your end credits
                <br />
                <em>in minutes.</em>
              </h1>
              <p className="sx-sub">
                Skip the manual formatting. Build,revise, and render end credits.
              </p>

              {/* Google button — outside sx-card to avoid overflow clipping */}
              <div className="sx-google-btn-wrapper">
                <div className="sx-google-custom-overlay">
                  <span className="sx-google-icon">G</span>
                  <span>Sign up with Google</span>
                </div>
                <div className="sx-google-actual-button">
                  <SignUpWithGoogle />
                </div>
              </div>

              <div className="sx-divider">or continue with email</div>

              <div className="sx-card">
                <form onSubmit={submitHandler}>
                  <div className="sx-field-grid">
                    {/* Full name */}
                    <div className="sx-field full">
                      <label className="sx-label" htmlFor="firstName">
                        Full name
                      </label>
                      <input
                        className="sx-input"
                        id="firstName"
                        name="firstName"
                        type="text"
                        placeholder="Ava"
                        autoComplete="given-name"
                        value={form.data.firstName}
                        onChange={onChangeHandler}
                        required
                      />
                      {form.errorMessage.firstName && (
                        <span className="sx-err">
                          {form.errorMessage.firstName}
                        </span>
                      )}
                    </div>

                    {/* Email */}
                    <div className="sx-field full">
                      <label className="sx-label" htmlFor="email">
                        Work email
                      </label>
                      <input
                        className="sx-input"
                        id="email"
                        name="email"
                        type="email"
                        placeholder="ava@studio.com"
                        autoComplete="email"
                        value={form.data.email}
                        onChange={onChangeHandler}
                        required
                      />
                      {form.errorMessage.email && (
                        <span className="sx-err">
                          {form.errorMessage.email}
                        </span>
                      )}
                    </div>

                    {/* Password */}
                    <div className="sx-field full">
                      <label className="sx-label" htmlFor="password">
                        Password
                      </label>
                      <div className="sx-pw-wrap">
                        <input
                          className="sx-input"
                          id="password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          placeholder="Create a password"
                          autoComplete="new-password"
                          value={form.data.password}
                          onChange={onChangeHandler}
                          required
                        />
                        <button
                          type="button"
                          className="sx-pw-toggle"
                          onClick={() => setShowPassword((p) => !p)}
                          tabIndex={-1}
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                        >
                          {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </button>
                      </div>
                      {form.errorMessage.password && (
                        <span className="sx-err">
                          {form.errorMessage.password}
                        </span>
                      )}
                    </div>

                    {/* Role dropdown */}
                    <div className="sx-field full">
                      <label className="sx-label" htmlFor="role">
                        What best describes your role?
                      </label>
                      <select
                        className="sx-select"
                        id="role"
                        value={answerTwo.value}
                        onChange={(e) => {
                          const opt = ROLE_OPTIONS.find(
                            (o) => o.value === e.target.value,
                          );
                          setAnswerTwo({
                            value: e.target.value,
                            label: opt?.label || "",
                          });
                        }}
                      >
                        <option value="" disabled>
                          Select your position
                        </option>
                        {ROLE_OPTIONS.map((o) => (
                          <option key={o.value} value={o.value}>
                            {o.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Discover dropdown */}
                  <div className="sx-field">
                    <label className="sx-label" htmlFor="discover">
                      How did you discover ScrollX?
                    </label>
                    <select
                      className="sx-select"
                      id="discover"
                      value={answer.value}
                      onChange={(e) => {
                        const opt = DISCOVER_OPTIONS.find(
                          (o) => o.value === e.target.value,
                        );
                        setAnswer({
                          value: e.target.value,
                          label: opt?.label || "",
                        });
                        setError("");
                      }}
                    >
                      <option value="" disabled>
                        Select one
                      </option>
                      {DISCOVER_OPTIONS.map((o) => (
                        <option key={o.value} value={o.value}>
                          {o.label}
                        </option>
                      ))}
                    </select>
                    {error && <span className="sx-err">{error}</span>}
                  </div>

                  <div className="sx-trial-banner">
                    <strong>
                      Set up your account to start your 3-day free trial.
                    </strong>
                  </div>

                  {termsConditionsError && (
                    <span className="sx-err">{termsConditionsError}</span>
                  )}

                  {/* Submit */}
                  <button
                    className="sx-submit"
                    type="submit"
                    disabled={signupLoading}
                  >
                    Get Started Now <span>→</span>
                  </button>

                  {/* Terms */}
                  <div className="sx-terms-row">
                    <input
                      className="sx-terms-check"
                      type="checkbox"
                      id="terms"
                      checked={terms}
                      onChange={(e) => {
                        setTerms(e.target.checked);
                        setTermsConditionError("");
                      }}
                    />
                    <p className="sx-terms-label">
                      By continuing, you agree to ScrollX's{" "}
                      <a href="/register/terms">Terms</a> and{" "}
                      <a href="/PrivacyPolicy">Privacy Policy</a>.
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </section>

          {/* ── Right — Social proof ── */}
          <section className="sx-right">
            <div className="sx-right-inner">
              <div className="sx-trust">
                <div className="sx-stat">
                  <strong>200+</strong>
                  <span>films and projects created with ScrollX</span>
                </div>
                <div className="sx-stat">
                  <strong>50+</strong>
                  <span>broadcast-ready credit templates</span>
                </div>
                <div className="sx-stat">
                  <strong>4K</strong>
                  <span>exports with major frame rates and formats</span>
                </div>
              </div>

              <div className="sx-value-card">
                <h2>
                  Save hours on
                  <br />
                  <em>end-credit revisions.</em>
                </h2>

                <div className="sx-feature-list">
                  {[
                    "Spreadsheet-based workflow",
                    "Major frame rates & formats",
                    "Custom fonts and studio logos",
                    "Upgrade anytime as your slate grows",
                  ].map((feat) => (
                    <div className="sx-feature" key={feat}>
                      <span className="sx-check">
                        <svg viewBox="0 0 16 16" fill="none" strokeWidth="2">
                          <path
                            d="M4 8l3 3 5-5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      {feat}
                    </div>
                  ))}
                </div>

                <div className="sx-preview">
                  <div className="sx-preview-head">
                    <span>Live Preview</span>
                    <span className="sx-preview-badge">4K Render</span>
                  </div>
                  <div className="sx-credit-preview">
                    <div className="sx-credit-line">
                      <span className="sx-credit-role">Directed by</span>
                      <span className="sx-credit-name">AVA MORGAN</span>
                    </div>
                    <div className="sx-credit-line">
                      <span className="sx-credit-role">Produced by</span>
                      <span className="sx-credit-name">ETHAN BROOKS</span>
                    </div>
                    <div className="sx-credit-line">
                      <span className="sx-credit-role">Edited by</span>
                      <span className="sx-credit-name">ZOE CARTER</span>
                    </div>
                  </div>
                </div>

                <div className="sx-quote">
                  <div className="sx-avatar">JM</div>
                  <div>
                    "What used to take a full day of formatting now takes twenty
                    minutes. Our producer just updates the sheet and we
                    re-render. Done."
                    <strong>Jamie M. · Post Supervisor</strong>
                  </div>
                </div>
              </div>
            </div>

          </section>
          <div className=" sm:hidden flex flex-col justify-center items-center">
            <div className="flex items-center justify-center pt-4">
              <span className="sx-check ">
                        <svg viewBox="0 0 16 16" fill="none" strokeWidth="2">
                          <path
                            d="M4 8l3 3 5-5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
              <div className="px-3 footertextSIgnup">
                Used on 200+ films
              </div>
            </div>
            <div className="flex items-center justify-center py-2">
              <span className="sx-check ">
                        <svg viewBox="0 0 16 16" fill="none" strokeWidth="2">
                          <path
                            d="M4 8l3 3 5-5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
              <div className="px-3 footertextSIgnup">
                Fast first drafts, no design skills needed
              </div>
            </div>
            <div className="flex items-center justify-center pb-4">
              <span className="sx-check ">
                        <svg viewBox="0 0 16 16" fill="none" strokeWidth="2">
                          <path
                            d="M4 8l3 3 5-5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
              <div className="px-3 footertextSIgnup ">
                Cancel anytime, no questions
              </div>
            </div>
            </div>
        </main>
      </div>
    </div>
  );
}
